import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import * as routes from '../constants/routes';
import TasksList from '../components/TasksList';
import Modal from '../components/Modal';
import Preloader from '../components/Preloader';
import TasksHistory from '../components/TasksHistory';

import { logout } from '../actions/webInterface';
import { loadTasksActual, loadTasksFinished, updateTask } from '../actions/tasksActions';
import appConfig from "../config/app";

const rotesWithoutTaskBlock = new Set([
	routes.MANAGE_TASKS,
	routes.CLIENTS_DETAIL,
	routes.SUPPLIER_DETAIL
]);
const fromSiteImage = require('../assets/images/from-site.png');
const routesData = {
	search: {
		title: 'Поиск',
		iconClass: 'flaticon-worldwide'
	},
    actual_enterprises: {
		title: 'Актуальные клиенты',
		iconClass: 'icon-actual-enterprises'
	},
	actual_offers: {
		title: 'Заявки на продажу',
		iconClass: 'icon-actual-enterprises'
	},
	supplier: {
		title: 'Поставщик',
		iconClass: 'flaticon-rice'
	},
	client: {
		title: 'Клиент',
		iconClass: 'flaticon-silo'
	},
	add: {
		title: 'Добавить',
		iconClass: 'flaticon-add-user-with-tie'
	},
	elevator: {
		title: 'Элеватор',
		iconClass: 'flaticon-silo-1'
	},
	from_site: {
		title: 'С сайта',
		iconUrl: fromSiteImage,
		href: ''
	}
};

class Layout extends Component {

	state = {
		isModalOpened: false
	}

	componentWillMount () {
		this.props.loadTasksFinished();
		this.props.loadTasksActual();
	}

	handleLogoutClick = e => {
		e.preventDefault();

		this.props.logout(() => this.props.history.push('/login'));
	}

	handleHistoryLinkCLick = (e) => {
		e.preventDefault();

		this.setState({
			isModalOpened: true
		});
	}

	closeModal = () => {
		this.setState({
			isModalOpened: false
		});
	}

	render () {
		const { modules, children, loading, actualTasks, finishedTasks, location, activeItemId, taskChanging, redBackground } = this.props;
		let routesKeys = Object.keys(routes);
		const showHistoryBlock = !rotesWithoutTaskBlock.has(location.pathname) && !modules.settings;

		const isActiveIntegration = appConfig.isActivePoleplanIntegration.toString() !== '0';
		if (!isActiveIntegration) {
			delete routesKeys[2];
		}

		return (
			<div className="main">
				{
					loading ?
						<Preloader /> :
						<div>
							<header className="header">
								<div className="settings-panel clearfix">
									<div className="container">
										<a href="" title="" className="pull-right header__link" onClick={this.handleLogoutClick} >Выход</a>
										{
											modules.settings ? 
												<NavLink activeClassName="active" exact className="pull-right" to="settings">
													<i className="fi flaticon-settings" />
												</NavLink> : null
										}
									</div>
								</div>
								<nav className="navigation">
									<div className="container">
										<div className="flex">
											{routesKeys.map(key => {
												const keyString = key.toLowerCase();
												if (keyString === 'settings') { return; }
												const isAddPageAvailable = keyString === 'add' && modules['can_add'];
												if (modules[keyString] || isAddPageAvailable) {
													const route = routesData[key.toLowerCase()];
                          return (
														<NavLink activeClassName="active" exact key={key} className="navigation__link" to={routes[key]}>
															<i className={`fi ${route.iconClass}`} /> {route.title}
														</NavLink>
													);
												}
											})}
											<a href={routesData.from_site.href} target="_blank" className="navigation__link">
												<img src={routesData.from_site.iconUrl} className="navigation__link-image" />
												{routesData.from_site.title}
											</a>
										</div>
									</div>
								</nav>
							</header>
							<div className={"content " + (this.props.redBackground ? 'background-red' : '')}>
								<div className="container">
									{actualTasks.length && showHistoryBlock ?
										<TasksList tasksList={actualTasks} list={finishedTasks} onHistoryLinkClick={this.handleHistoryLinkCLick} /> : null}
									{
										!actualTasks.length && finishedTasks.length && !modules.settings ?
											<a href="#" className="pull-right task-history-link" onClick={this.handleHistoryLinkCLick}>История задач</a> : null
									}
								</div>
								{children}
							</div>

							{ finishedTasks.length || actualTasks.length ?
								<Modal onCloseClick={this.closeModal} isOpened={this.state.isModalOpened}>
									<TasksHistory list={actualTasks.concat(finishedTasks)} taskChanging={taskChanging} activeItemId={activeItemId} updateTask={this.props.updateTask} loadTasksFinished={this.props.loadTasksFinished}/>
								</Modal> : null
							}
						</div>
				}
			</div>
		);
	}
}

Layout.propTypes = {
	children: PropTypes.any,
	logout: PropTypes.func.isRequired,
	modules: PropTypes.object,
	loading: PropTypes.bool,
	taskChanging: PropTypes.bool,
	activeItemId: PropTypes.number,
	loadTasksFinished: PropTypes.func.isRequired,
	loadTasksActual: PropTypes.func.isRequired,
	updateTask: PropTypes.func.isRequired,
	finishedTasks: PropTypes.array,
	actualTasks: PropTypes.array,
	location: PropTypes.object,
	history: PropTypes.object,
	redBackground: PropTypes.bool
};

const mapStateToProps = ({ webInterface: { authToken, initData, loading }, tasks: { finished, actual, loading: tasksLoading, updating: taskChanging, activeItemId } }, ownProps) => ({
	...ownProps,
	authToken,
	modules: initData ? initData.available_modules : {},
	tasks: initData ? initData.tasks : [],
	loading: loading || tasksLoading,
	taskChanging,
	finishedTasks: finished,
	actualTasks: actual,
	activeItemId
});

const mapDipatchToProps = dispatch => ({
	logout: () => dispatch(logout()),
	loadTasksFinished: () => dispatch(loadTasksFinished()),
	loadTasksActual: () => dispatch(loadTasksActual()),
	updateTask: (data, id) => dispatch(updateTask(data, id))
});

export default connect(mapStateToProps, mapDipatchToProps)(withRouter(Layout));



// WEBPACK FOOTER //
// ./containers/Layout.js